// NAV-2026-10-22: a row of filter buttons at the top of a nav item (Needs a human, Candidates): the views that used to be tabs
// of their own. Each is a real button, at least 44px tall, with its count; the current one is pressed. The row wraps onto a
// second line on a phone, so the page never scrolls sideways.
export default function FilterRow({ label, items, current, onPick, counts = {}, testid }) {
  return (
    <div role="group" aria-label={label} data-testid={testid}
      style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '0 0 12px', maxWidth: '100%' }}>
      {items.map((it) => {
        const on = current === it.id;
        const n = counts[it.id];
        return (
          <button key={it.id} className="nb" data-testid={`${testid}-${it.id}`} aria-pressed={on} onClick={() => onPick(it.id)}
            style={{ flex: '0 0 auto', minHeight: 44, borderRadius: 22, padding: '0 14px', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
              background: on ? '#0f2744' : '#f1f5f9', color: on ? 'white' : '#334155', border: 0 }}>
            {it.label}{n ? <span data-testid={`${testid}-${it.id}-count`} style={{ marginLeft: 6, opacity: 0.85 }}>{n}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
